import { render } from "./FavouriteStar.vue?vue&type=template&id=aff0051c"
import script from "./FavouriteStar.vue?vue&type=script&lang=js"
export * from "./FavouriteStar.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/members.eena.org/releases/81761477/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__